import trimWhiteSpace from './trimWhiteSpace';

const fieldRequired = (value) => {
    if (value == null || trimWhiteSpace(value) === '' || trimWhiteSpace(value) === 'default') {
        return 'This field is required!';
    }
    return undefined;
};

export default fieldRequired;



// WEBPACK FOOTER //
// ./src/client/utils/fieldRequired.js